import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Route, Switch }  from 'react-router-dom';

import LayoutContainer from '../../containers/Layout';
import SuccessDialog from '../../components/dialogs/SuccessDialog';
import ErrorDialog from '../../components/dialogs/ErrorDialog';

//- Pages / Route
import DriverRoomSchedule from './DriverRoomSchedule';

const styles = () => {
	return {
		root : {
			backgroundColor: 'white',
		}
	};
};

const NoMatch = () => (
	<div>
		<h2>Invalid URL. Please check your URL again or contact support.</h2>
	</div>
);

class MinimalLayout extends Component {
	constructor(props){
		super(props);
		this.state = {
			isSuccessDialogOpen : false,
			isErrorDialogOpen : false,
		};
	}

	handleSuccessClose = () => {
		this.props.clearSuccess();
		this.props.history.push(this.props.onSuccessRedirectTo);
	};

	render() {
		// noinspection JSMismatchedCollectionQueryUpdate
		const { classes,
			successMessages = [],
			errorMessages = [],
		} = this.props;

		const isSuccessDialogOpen = (successMessages.length !== 0);
		const isErrorDialogOpen = (errorMessages.length !== 0);

		return (
			<div className={classes.root}>
				<Switch>
					<Route
						exact
						path="/minimal/driverRoomSchedule/:locationId?/:shiftId?/:securityToken?"
						component={DriverRoomSchedule}
					/>
					<Route component={NoMatch}/>
				</Switch>

				<ErrorDialog
					onClose={this.props.clearError}
					errorMessages={errorMessages}
					open={isErrorDialogOpen}
				/>

				<SuccessDialog
					onClose={this.handleSuccessClose}
					successMessages={successMessages}
					open={isSuccessDialogOpen}
				/>
			</div>
		);
	}
}

MinimalLayout.propTypes = {
	classes: PropTypes.object.isRequired,
	onSuccessRedirectTo : PropTypes.string,
	successMessages : PropTypes.array,
	errorMessages : PropTypes.array,
	clearError : PropTypes.func,
	clearSuccess : PropTypes.func,
	history : PropTypes.object,
};

export default _.flow([
	withStyles(styles),
	LayoutContainer,
])(MinimalLayout);
